export const AMPLITUDE_READY_EVENT = 'hcp-amplitude-ready';
export const EXPERIMENT_RESULTS_GLOBAL_KEY = 'hcpExperimentResults';
export const URL_SOLVABLE_EXPERIMENT_PREFIX = 'hcpab-';
